<div class="container">
  <div class="row">
    <div class="col" style="margin: 15px 0;">
      <h2>Заявление исполнительного органа ООО «Эвномия Аудит» о мерах,
        принимаемых для обеспечения независимости</h2>
      <p>В основе нашего подхода к оказанию аудиторских услуг лежат фундаментальные
        принципы профессиональной этики, закрепленные в Кодексе профессиональной этики аудиторов
        и Правилах независимости аудиторов и аудиторских организаций.</p>
      <p>Политика и процедуры, позволяющие обеспечить разумную уверенность в том, что ООО
        «Эвномия Аудит», его сотрудники и, если применимо, другие лица, на которых распространяется
        требование к независимости, соблюдают указанное требование, когда это требуется
        применяемыми этическими нормами, закреплены во внутреннем положении «Правила
        независимости». Данное положение регламентирует порядок выявления и оценки обстоятельств и
        взаимоотношений, создающих угрозы независимости, принятия надлежащих мер для устранения
        или снижения таких угроз до приемлемого уровня или (если необходимо) отказа от выполнения
        задания, а также порядок доведения требования о независимости до сведения сотрудников и иных
        лиц, на которых распространяется такое требование.</p>
      <p>При решении вопроса о том, следует ли принимать то или иное задание, проводится
        внутренняя проверка соблюдения независимости. Контроль за соблюдением независимости
        Общества, его сотрудниками и, если применимо, другими лицами, на которых распространяется
        требование к независимости, осуществляет генеральный директор Общества. Все сотрудники
        обязаны своевременно уведомлять генерального директора об обстоятельствах и отношениях,
        которые могут создавать угрозу независимости, для того чтобы можно было принять надлежащие
        меры.</p>
      <p>Исполнительный орган заявляет, что ООО «Эвномия Аудит» полностью соблюдает
        требования к независимости, установленные статьей 8 «Независимость аудиторских организаций, аудиторов» Федерального закона № 307-ФЗ «Об аудиторской деятельности» и Правилами
        независимости аудиторов и аудиторских организаций и принимает для этого все необходимые
        меры, в том числе, проводит внутренние проверки соблюдения независимости.</p>
    </div>
  </div>
</div>
